import React from "react";
import logo from "./assets/Admify_Logo.png";
import whatsappIcon from "./assets/whatsapp.png";
import pc from "./assets/pc.png";

function Hero() {
  return (
    <section id="inicio" className="bg-white text-[var(--color-dark)] py-20 relative overflow-hidden">
      <div className="container grid md:grid-cols-2 gap-12 items-center">
        
        {/* Columna de texto centrada */}
        <div className="flex flex-col items-center text-center relative z-10">
          <h2 className="text-4xl font-bold mb-6">
            Bienvenido a <span className="text-[var(--color-accent)]">Admify</span>
          </h2>

          <img
            src={logo}
            alt="Admify Logo"
            className="h-24 w-24 object-contain mb-6"
          />

          <p className="text-lg mb-4 leading-relaxed opacity-90 max-w-md">
            Nuestro objetivo es ofrecerte soluciones administrativas,
            contables y tecnológicas diseñadas para facilitar la gestión de tu negocio.
          </p>
          <p className="text-lg mb-4 leading-relaxed opacity-90 max-w-md">
            Ya sea que necesites asistencia con la administración de tu emprendimiento,
            desarrollo web o gestión de proyectos, estamos aquí para apoyarte en cada paso.
          </p>
          <p className="text-lg mb-6 leading-relaxed opacity-90 max-w-md">
            Explora nuestros servicios y descubrí cómo podemos ayudarte a crecer de manera
            eficiente y profesional.
          </p>

          {/* CTA */}
          <div className="flex flex-col items-center gap-6 mt-4">
            <a href="#servicios" className="btn btn-primary">
              Ver Servicios
            </a>
            <a
              href="https://wa.me/5493585727260"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:scale-110 transition-transform"
            >
              <img
                src={whatsappIcon}
                alt="WhatsApp"
                className="w-12 h-12"
              />
            </a>
          </div>
        </div>

        {/* Columna derecha con semicírculo */}
        <div className="relative flex items-center justify-center">
          {/* Semicírculo azul hasta la mitad */}
          <div className="absolute top-0 right-0 h-full w-[100%] bg-[var(--color-dark)] rounded-l-full opacity-10"></div>

          {/* Imagen centrada en el semicírculo */}
          <img
            src={pc}
            alt="Admify PC"
            className="relative w-80 max-w-full z-10 drop-shadow-md"
          />
        </div>
      </div>
    </section>
  );
}

export default Hero;






